export const userQueryKeys = {
  current: ['user', 'current'],
};

